import iPolaroidBeginning from "../../../assets/img/abous-us-page/polaroid-beginning.png";
import iLine from "../../../assets/icons/about-us-page/line.svg";
import iBgRight from "../../../assets/img/abous-us-page/hero-description-bg-right.png";
import iBgLeft from "../../../assets/img/abous-us-page/hero-description-bg-left.png";
import "./about-us-hero-description-block.sass";

const AboutUsHeroDescriptionBlock = () => {
  return (
    <div className="about-us-hero-description-block">
      <div className="about-us-hero-description-block__background" />

      <div className="about-us-hero-description-block__text">
        Один маленький кабинет, актовый зал на прокат
        <br /> и единое правило —
        <span className="about-us-hero-description-block__text-special">
          {" "}
          играем&nbsp;честно.
        </span>
        <br />
        <br />
        ТАК НАЧИНАЛСЯ CREON, А СЕЙЧАС МЫ ОДНО ИЗ САМЫХ ИЗВЕСТНЫХ АГЕНТСТВ МОСКВЫ
      </div>

      <div className="about-us-hero-description-block__polaroid">
        <img
          src={iPolaroidBeginning}
          className="about-us-hero-description-block__photo"
          alt=""
        />
      </div>

      <img
        src={iLine}
        className="img-absolute about-us-hero-description-block__line"
        alt=""
      />

      <img
        src={iBgRight}
        className="img-absolute about-us-hero-description-block__bg-right"
        alt=""
      />
      <img
        src={iBgLeft}
        className="img-absolute about-us-hero-description-block__bg-left"
        alt=""
      />
    </div>
  );
};

export default AboutUsHeroDescriptionBlock;
